import { render, staticRenderFns } from "./Gdr.vue?vue&type=template&id=e2555dc2&"
import script from "./Gdr.vue?vue&type=script&lang=js&"
export * from "./Gdr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports